import React from 'react'
import ContentLoader from "react-content-loader";
import '../styles/marketValueSummaryV2.scss'

function MarketValueSummaryV2Loader(){
    return (
        <div className="market-value-summary-container market-value-summary-loading">
            <div className="market-value-summary-loading-desktop">
                <ContentLoader
                    uniqueKey="mvs-v2-loader-desktop"
                    width={880}
                    height={1360}
                    viewBox="0 0 880 1360"
                    backgroundColor="#e4e4e4"
                    foregroundColor="#efefef"
                    style={{ width: "100%", height: "auto", display: "block" }}
                >
                    {/* Hero header */}
                    <rect x="24" y="28" rx="5" ry="5" width="240" height="22" />
                    <rect x="380" y="32" rx="4" ry="4" width="60" height="14" />
                    <rect x="24" y="60" rx="4" ry="4" width="300" height="14" />
                    <rect x="24" y="150" rx="14" ry="14" width="110" height="28" />
                    <rect x="146" y="157" rx="4" ry="4" width="220" height="14" />
                    <rect x="470" y="0" rx="5" ry="5" width="410" height="200" />

                    {/* Price breakdown: strong buy candidate */}
                    <rect x="683" y="228" rx="12" ry="12" width="128" height="24" />
                    <rect x="73" y="232" rx="4" ry="4" width="300" height="16" />
                    <rect x="73" y="258" rx="4" ry="4" width="600" height="12" />
                    <rect x="73" y="276" rx="4" ry="4" width="560" height="12" />
                    <rect x="73" y="296" rx="4" ry="4" width="60" height="12" />

                    {/* Price breakdown: dealer price, market value, you save */}
                    {[73, 233, 393].map((x) => (
                        <React.Fragment key={x}>
                            <rect x={x} y="336" rx="4" ry="4" width="80" height="12" />
                            <rect x={x} y="354" rx="5" ry="5" width="120" height="24" />
                            <rect x={x} y="384" rx="4" ry="4" width="90" height="12" />
                        </React.Fragment>
                    ))}

                    {/* Price breakdown: reconditioning CTA */}
                    <rect x="580" y="340" rx="4" ry="4" width="170" height="14" />
                    <rect x="580" y="362" rx="4" ry="4" width="230" height="12" />
                    <rect x="580" y="382" rx="4" ry="4" width="120" height="12" />

                    {/* Next steps */}
                    <rect x="57" y="432" rx="5" ry="5" width="220" height="18" />
                    {[57, 272].map((x) => (
                        <rect key={x} x={x} y="460" rx="5" ry="5" width="205" height="64" />
                    ))}

                    {/* MSRP comparison */}
                    <rect x="57" y="546" rx="5" ry="5" width="200" height="18" />
                    <rect x="57" y="574" rx="4" ry="4" width="340" height="14" />
                    <rect x="57" y="600" rx="5" ry="5" width="766" height="220" />

                    {/* Comparables */}
                    <rect x="57" y="842" rx="5" ry="5" width="240" height="18" />
                    <rect x="57" y="870" rx="4" ry="4" width="720" height="12" />
                    <rect x="57" y="888" rx="4" ry="4" width="520" height="12" />
                    <rect x="66" y="916" rx="3" ry="3" width="80" height="16" />
                    {[924, 1004, 1084, 1164].map((y) => (
                        <React.Fragment key={y}>
                            <rect x="73" y={y + 14} rx="4" ry="4" width="220" height="16" />
                            <rect x="73" y={y + 38} rx="4" ry="4" width="260" height="12" />
                            <rect x="723" y={y + 20} rx="5" ry="5" width="100" height="20" />
                            <rect x="57" y={y + 66} width="766" height="1" />
                        </React.Fragment>
                    ))}

                    {/* Attached module */}
                    <rect x="57" y="1236" rx="4" ry="4" width="260" height="16" />
                    <rect x="57" y="1260" rx="4" ry="4" width="520" height="12" />
                    <circle cx="807" cy="1250" r="12" />

                    {/* Disclaimer */}
                    <rect x="57" y="1300" rx="4" ry="4" width="766" height="10" />
                    <rect x="57" y="1318" rx="4" ry="4" width="720" height="10" />
                    <rect x="57" y="1336" rx="4" ry="4" width="680" height="10" />
                </ContentLoader>
            </div>

            <div className="market-value-summary-loading-mobile">
                <ContentLoader
                    uniqueKey="mvs-v2-loader-mobile"
                    width={375}
                    height={1800}
                    viewBox="0 0 375 1800"
                    backgroundColor="#e4e4e4"
                    foregroundColor="#efefef"
                    style={{ width: "100%", height: "auto", display: "block" }}
                >
                    {/* Hero header: text panel over image */}
                    <rect x="16" y="20" rx="5" ry="5" width="220" height="20" />
                    <rect x="16" y="48" rx="4" ry="4" width="260" height="12" />
                    <rect x="16" y="76" rx="13" ry="13" width="100" height="26" />
                    <rect x="126" y="82" rx="4" ry="4" width="180" height="14" />
                    <rect x="0" y="130" width="375" height="170" />

                    {/* Price breakdown: strong buy candidate */}
                    <rect x="36" y="322" rx="11" ry="11" width="174" height="26" />
                    <rect x="16" y="352" rx="4" ry="4" width="240" height="16" />
                    <rect x="16" y="378" rx="4" ry="4" width="343" height="12" />
                    <rect x="16" y="396" rx="4" ry="4" width="320" height="12" />
                    <rect x="16" y="414" rx="4" ry="4" width="280" height="12" />
                    <rect x="16" y="434" rx="4" ry="4" width="60" height="12" />

                    {/* Price breakdown: dealer price, market value, you save (2x2 with CTA) */}
                    {[[28, 474], [200, 474], [28, 554]].map(([x, y]) => (
                        <React.Fragment key={`${x}-${y}`}>
                            <rect x={x} y={y} rx="4" ry="4" width="70" height="12" />
                            <rect x={x} y={y + 18} rx="5" ry="5" width="95" height="22" />
                            <rect x={x} y={y + 46} rx="4" ry="4" width="120" height="10" />
                        </React.Fragment>
                    ))}
                    <rect x="187" y="474" width="1" height="56" />
                    <rect x="170" y="554" width="1" height="56" />

                    {/* Price breakdown: reconditioning CTA */}
                    <rect x="183" y="566" rx="4" ry="4" width="150" height="14" />
                    <rect x="183" y="588" rx="4" ry="4" width="110" height="12" />

                    {/* Next steps */}
                    <rect x="0" y="652" rx="5" ry="5" width="230" height="18" />
                    {[680, 750, 820].map((y) => (
                        <rect key={y} x="0" y={y} rx="5" ry="5" width="375" height="60" />
                    ))}

                    {/* MSRP comparison */}
                    <rect x="16" y="902" rx="5" ry="5" width="180" height="18" />
                    <rect x="16" y="928" rx="4" ry="4" width="300" height="12" />
                    <rect x="16" y="952" rx="5" ry="5" width="343" height="200" />

                    {/* Comparables */}
                    <rect x="16" y="1174" rx="5" ry="5" width="220" height="18" />
                    <rect x="16" y="1200" rx="4" ry="4" width="343" height="12" />
                    <rect x="16" y="1216" rx="4" ry="4" width="300" height="12" />
                    <rect x="16" y="1232" rx="4" ry="4" width="200" height="12" />
                    <rect x="24" y="1260" rx="3" ry="3" width="76" height="16" />
                    {[1268, 1364, 1460, 1556].map((y) => (
                        <React.Fragment key={y}>
                            <rect x="28" y={y + 14} rx="4" ry="4" width="200" height="14" />
                            <rect x="28" y={y + 36} rx="4" ry="4" width="240" height="12" />
                            <rect x="259" y={y + 60} rx="5" ry="5" width="100" height="18" />
                            <rect x="16" y={y + 88} width="343" height="1" />
                        </React.Fragment>
                    ))}

                    {/* Attached module */}
                    <rect x="16" y="1676" rx="4" ry="4" width="220" height="14" />
                    <rect x="16" y="1698" rx="4" ry="4" width="280" height="12" />
                    <circle cx="347" cy="1688" r="11" />

                    {/* Disclaimer */}
                    <rect x="16" y="1730" rx="4" ry="4" width="343" height="10" />
                    <rect x="16" y="1746" rx="4" ry="4" width="330" height="10" />
                    <rect x="16" y="1762" rx="4" ry="4" width="343" height="10" />
                    <rect x="16" y="1778" rx="4" ry="4" width="250" height="10" />
                </ContentLoader>
            </div>
        </div>
    )
}

export default MarketValueSummaryV2Loader;
